import React from "react"
import styled, { css } from "styled-components"
import MenuItems from "./MenuItems"
import { Link } from "gatsby"

import Typography from "@material-ui/core/Typography"

import * as theme from "../../theme"

const MainMenu = ({ pinned }) => {
  return (
    <Menu>
      <MenuItems slug="main-menu">
        {items => {
          return items.map(
            ({
              pathname,
              active,
              activeParent,
              title,
              children,
              wordpress_id
            }) => (
              <ItemWrapper key={wordpress_id}>
                <Item
                  pinned={pinned ? 1 : undefined}
                  to={pathname}
                  className={active || activeParent ? "active" : ""}
                >
                  <Title pinned={pinned ? 1 : undefined} className="item-title">
                    {title}
                  </Title>
                </Item>
                {children && (
                  <Dropdown className="drop-down-menu">
                    {children.map((subItem, index) => (
                      <SubItem
                        key={subItem.wordpress_id}
                        href={subItem.pathname}
                        target={
                          subItem.pathname.includes("http")
                            ? "_blank"
                            : undefined
                        }
                      >
                        <Title disableUnderline>{subItem.title}</Title>
                      </SubItem>
                    ))}
                  </Dropdown>
                )}
              </ItemWrapper>
            )
          )
        }}
      </MenuItems>
    </Menu>
  )
}

export default MainMenu

const Dropdown = styled.div`
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 100%;
  left: calc(50% - 90px);

  background: ${theme.color.primary};
  padding: 10px 0;
  width: 180px;
  color: white;
`

const SubItem = styled.a`
  color: inherit;
  text-decoration: none;
  display: block;
  padding: 10px 20px;
  &:hover {
    background: rgba(255, 255, 255, 0.02);
  }
`

const Menu = styled.nav`
  display: flex;
  align-items: center;
  .active {
    .item-title {
      &:after {
        transform: scaleX(1);
      }
    }
  }
`

const ItemWrapper = styled.div`
  position: relative;

  &:hover {
    .drop-down-menu {
      opacity: 1;
      pointer-events: all;
    }
  }
`
const Item = styled(Link)`
  color: inherit;
  text-decoration: none;
  padding: 8px 16px;
  display: block;
`
const NavItem = ({ pinned, ...rest }) => {
  return <Typography {...rest} variant="subtitle2" />
}
const Title = styled(NavItem)`
  padding: 5px 0;
  color: inherit;
  text-transform: uppercase;
  margin-top: 2px;

  ${({ disableUnderline }) =>
    !disableUnderline &&
    css`
      &:hover {
        &:after {
          transform: scaleX(1);
        }
      }

      &:after {
        display: block;
        content: "";
        border-bottom: solid 2px
          ${({ pinned }) => (pinned ? theme.color.primary : "white")};
        transform: scaleX(0);
        transition: transform 150ms ease-in-out;
      }
    `}
`
